import { DestroyRef, Directive, ElementRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatMenuTrigger } from '@angular/material/menu';

@Directive({
  selector: '[iotPlatformUiMenuMatchTriggerWidth]'
})
export class MenuMatchTriggerWidthDirective implements OnInit {
  private readonly trigger = inject(MatMenuTrigger);
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.trigger.menuOpened.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      const triggerWidth = this.elementRef.nativeElement.getBoundingClientRect().width;
      const panelId = this.trigger.menu?.panelId;
      if (!panelId) {
        return;
      }
      setTimeout(() => {
        const pane = document.getElementById(panelId)?.closest<HTMLElement>('.cdk-overlay-pane');
        if (pane) {
          pane.style.width = `${triggerWidth}px`;
          pane.style.minWidth = `${triggerWidth}px`;
          pane.style.maxWidth = `${triggerWidth}px`;
        }
      });
    });
  }
}
